import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import './index.scss'
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getInfo} from "../../../../servers/menuAPI";
import {refreshMenu} from "../../../../redux/common/action";
import { tableData } from './data'
import CTable from '@/components/CTable'

@CBaseComponent
class SystemScore extends Component{

  constructor(props) {
    super(props);
    this.onSubmit= this.onSubmit.bind(this)
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    detaildata:[]
  }
  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      indid:'4.3',
      museumid:localStorage.getItem('library'),
    }
    getInfo(params).then(res=>{
      this.setState({
        dataSource:res.records,
      })
    })
  }

  onSubmit(){
    this.props.history.push({
      pathname: '/progressCentral',
    });
  }

  componentDidMount(){
    this.onSelect()
  }

  render(){
    return (
        <div className='user-manage-list detail-container-suggest'>
            <CTable ref='userManageList' checked={false} loading={false} columns={this.state.columns} dataSource={this.state.dataSource}>
              <div
                  slot='index'
                  render={(text, record, index) => (
                      <div className='operate'>
                        {index+1}
                      </div>
                  )} />
              <div
                  slot='suggest'
                  render={(text, record, index) => (
                      <div className='operate'>
                        {decodeURIComponent(record.notes)}
                      </div>
                  )} />
            </CTable>
        </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(SystemScore);
